import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import enAdmin from "./locales/en/admin.json"
import enApiExplorer from "./locales/en/apiExplorer.json"
import enApiTokens from "./locales/en/apiTokens.json"
import enAuth from "./locales/en/auth.json"
import enCommon from "./locales/en/common.json"
import enDashboard from "./locales/en/dashboard.json"
import enDemo from "./locales/en/demo.json"
import enDpp from "./locales/en/dpp.json"
import enEvents from "./locales/en/events.json"
import enIpBans from "./locales/en/ipBans.json"
import enItems from "./locales/en/items.json"
import enReaders from "./locales/en/readers.json"
import enSettings from "./locales/en/settings.json"
import enTags from "./locales/en/tags.json"

import frAdmin from "./locales/fr/admin.json"
import frApiExplorer from "./locales/fr/apiExplorer.json"
import frApiTokens from "./locales/fr/apiTokens.json"
import frAuth from "./locales/fr/auth.json"
import frCommon from "./locales/fr/common.json"
import frDashboard from "./locales/fr/dashboard.json"
import frDemo from "./locales/fr/demo.json"
import frDpp from "./locales/fr/dpp.json"
import frEvents from "./locales/fr/events.json"
import frIpBans from "./locales/fr/ipBans.json"
import frItems from "./locales/fr/items.json"
import frReaders from "./locales/fr/readers.json"
import frSettings from "./locales/fr/settings.json"
import frTags from "./locales/fr/tags.json"

import esAdmin from "./locales/es/admin.json"
import esApiExplorer from "./locales/es/apiExplorer.json"
import esApiTokens from "./locales/es/apiTokens.json"
import esAuth from "./locales/es/auth.json"
import esCommon from "./locales/es/common.json"
import esDashboard from "./locales/es/dashboard.json"
import esDemo from "./locales/es/demo.json"
import esDpp from "./locales/es/dpp.json"
import esEvents from "./locales/es/events.json"
import esIpBans from "./locales/es/ipBans.json"
import esItems from "./locales/es/items.json"
import esReaders from "./locales/es/readers.json"
import esSettings from "./locales/es/settings.json"
import esTags from "./locales/es/tags.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        readers: enReaders,
        tags: enTags,
        events: enEvents,
        items: enItems,
        settings: enSettings,
        admin: enAdmin,
        apiExplorer: enApiExplorer,
        apiTokens: enApiTokens,
        demo: enDemo,
        dpp: enDpp,
        ipBans: enIpBans,
      },
      fr: {
        common: frCommon,
        auth: frAuth,
        dashboard: frDashboard,
        readers: frReaders,
        tags: frTags,
        events: frEvents,
        items: frItems,
        settings: frSettings,
        admin: frAdmin,
        apiExplorer: frApiExplorer,
        apiTokens: frApiTokens,
        demo: frDemo,
        dpp: frDpp,
        ipBans: frIpBans,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        dashboard: esDashboard,
        readers: esReaders,
        tags: esTags,
        events: esEvents,
        items: esItems,
        settings: esSettings,
        admin: esAdmin,
        apiExplorer: esApiExplorer,
        apiTokens: esApiTokens,
        demo: esDemo,
        dpp: esDpp,
        ipBans: esIpBans,
      },
    },
    defaultNS: "common",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18n_language",
    },
  })

export default i18n
